import React from 'react';
import { NavLink } from 'react-router-dom';

export default function FloatingSidebar({ counts = {}, embedded = false }) {
    const base = '/mon-compte';

    const menuItems = [
        { to: base, exact: true, label: 'Accueil', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> },
        { to: `${base}/profil`, label: 'Profil', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> },
        { to: `${base}/projets`, label: 'Projets', countKey: 'projects', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg> },
        { to: `${base}/devis`, label: 'Devis', countKey: 'quotes', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
        { to: `${base}/factures`, label: 'Factures', countKey: 'invoices', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg> },
        { to: `${base}/contrats`, label: 'Contrats', countKey: 'contracts', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg> },
        { to: `${base}/coffre-fort`, label: 'Coffre-fort', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg> },
        { to: `${base}/rendez-vous`, label: 'Rendez-vous', countKey: 'meetings', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> },
        { to: `${base}/messages`, label: 'Messages', countKey: 'messages', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> },
    ];

    return (
        <>
            <style>{`
                /* Shared Visual Styles for Desktop (Fixed & Embedded) */
                .floating-sidebar {
                    background: rgba(255, 255, 255, 0.75);
                    backdrop-filter: blur(16px);
                    -webkit-backdrop-filter: blur(16px);
                    border: 1px solid rgba(255, 255, 255, 0.4);
                    box-shadow: 
                        0 4px 6px -1px rgba(0, 0, 0, 0.05),
                        0 10px 15px -3px rgba(0, 0, 0, 0.05),
                        0 0 0 1px rgba(0,0,0,0.02);
                    border-radius: 20px;
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    z-index: 40;
                    transition: all 0.3s ease;
                }

                /* Positioning: Fixed Mode */
                .floating-sidebar:not(.embedded) {
                    position: fixed;
                    top: calc(var(--top-chrome-height, 80px) + 20px);
                    left: 20px;
                    width: 240px;
                }

                /* Positioning: Embedded Mode (Sticky) */
                .floating-sidebar.embedded {
                    width: 100%;
                    /* Important: Resetting potential conflicting props is NOT needed if shared styles are applied correctly */
                    background: rgba(255, 255, 255, 0.75); /* Re-assert background just in case */
                }

                /* Dark Mode Styles */
                .dark .floating-sidebar.embedded,
                .dark .floating-sidebar:not(.embedded) {
                    background: #0f172a; /* Solid Slate-900 */
                    border: 1px solid rgba(99, 102, 241, 0.4) !important; /* Force Violet Border */
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.5), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
                }

                /* Base Item Styles */
                .sidebar-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 10px 14px;
                    border-radius: 12px;
                    color: #64748b;
                    text-decoration: none;
                    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                    font-weight: 500;
                    font-size: 0.95rem;
                    border: 1px solid transparent; /* Prepare for border transition */
                }
                .sidebar-item:hover {
                    background: rgba(99, 102, 241, 0.04);
                    color: #4f46e5;
                    border-color: rgba(99, 102, 241, 0.3);
                    transform: translateX(2px);
                }
                .sidebar-item.active {
                    background: rgba(99, 102, 241, 0.08); /* Light Indigo bg */
                    color: #4338ca; /* Darker Indigo text */
                    font-weight: 600;
                    border-color: #6366f1; /* The requested Blue Border */
                    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
                }
                /* Dark Mode Item Styles */
                .dark .sidebar-item { color: #94a3b8; }
                .dark .sidebar-item:hover {
                    background: rgba(99, 102, 241, 0.1);
                    color: #a5b4fc;
                    border-color: rgba(129, 140, 248, 0.4);
                }
                .dark .sidebar-item.active {
                    background: rgba(99, 102, 241, 0.2);
                    color: #a5b4fc;
                    border-color: #818cf8;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                }
                .sidebar-icon {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .sidebar-badge {
                    margin-left: auto;
                    font-size: 0.7rem;
                    font-weight: 800;
                    padding: 2px 7px;
                    border-radius: 8px;
                    background: #f1f5f9;
                    color: #475569;
                    min-width: 18px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.05);
                    transition: all 0.3s ease;
                }
                .sidebar-item:hover .sidebar-badge {
                    transform: scale(1.1);
                    background: #3b82f6;
                    color: white;
                }
                .sidebar-item.active .sidebar-badge {
                    background: #3b82f6;
                    color: white;
                    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.3);
                    animation: badgePop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
                }

                @keyframes badgePop {
                    from { transform: scale(0.5); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }

                /* Dark Mode Text/Hover */
                .dark .sidebar-item { color: #cbd5e1; }
                .dark .sidebar-item:hover {
                    background: rgba(255, 255, 255, 0.05);
                    color: #fff;
                }
                .dark .sidebar-item.active {
                    background: rgba(99, 102, 241, 0.15); /* Indigo tint */
                    color: #fff;
                    border: 1px solid rgba(99, 102, 241, 0.3);
                    box-shadow: 0 0 15px rgba(99, 102, 241, 0.1);
                }
                .dark .sidebar-icon { color: #a5b4fc; /* Indigo-300 */ }
                .dark .sidebar-item.active .sidebar-icon { color: #818cf8; /* Indigo-400 */ }

                /* Mobile Floating Dock (Fixed at bottom) */
                @media (max-width: 1024px) {
                    .floating-sidebar, .floating-sidebar.embedded {
                        position: fixed !important; /* Force fixed on mobile */
                        top: auto !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 0 !important;
                        width: 100% !important;
                        max-width: none !important;
                        
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        overflow-x: auto;
                        padding: 12px 16px;
                        padding-bottom: calc(12px + env(safe-area-inset-bottom)); /* iOS Safe Area */
                        border-radius: 0;
                        gap: 8px;
                        margin: 0;
                        
                        background: rgba(255, 255, 255, 0.98);
                        backdrop-filter: blur(20px);
                        border-top: 1px solid rgba(0,0,0,0.05);
                        border-left: none; border-right: none; border-bottom: none;
                        box-shadow: 0 -4px 20px rgba(0,0,0,0.05);
                        z-index: 9999;
                    }

                    .dark .floating-sidebar, .dark .floating-sidebar.embedded {
                        background: #0f172a;
                        border-color: #1e293b;
                        box-shadow: 0 8px 32px rgba(0,0,0,0.5);
                    }

                    /* Hide badge text on tiny screens if needed, keep dot */
                    .sidebar-item {
                        flex-direction: column;
                        gap: 4px;
                        padding: 6px 4px;
                        min-width: 64px;
                        border-radius: 12px;
                        font-size: 0.65rem;
                        text-align: center;
                    }
                    
                    .sidebar-item.active {
                        background: transparent;
                        color: #4f46e5;
                        box-shadow: none;
                        border: none;
                    }
                    .dark .sidebar-item.active {
                        background: transparent;
                        color: #818cf8;
                        box-shadow: none;
                        border: none;
                    }
                    
                    .sidebar-icon { margin-bottom: 2px; }
                    .sidebar-icon svg { width: 24px; height: 24px; }
                    
                    /* Badges for mobile */
                    .sidebar-badge {
                        position: absolute;
                        top: 6px;
                        right: 12px;
                        margin: 0;
                        padding: 2px 5px;
                        min-width: auto;
                        font-size: 0.6rem;
                        border: 2px solid #fff; /* Border to separate from icon */
                        transform: translate(25%, -25%);
                    }
                    .dark .sidebar-badge { border-color: #0f172a; }
                    
                    /* Hide scrollbar */
                    .floating-sidebar::-webkit-scrollbar { display: none; }
                    .floating-sidebar { -ms-overflow-style: none; scrollbar-width: none; }
                }
            `}</style>

            <nav className={`floating-sidebar ${embedded ? 'embedded' : ''}`}>
                {menuItems.map((item) => {
                    const count = item.countKey ? counts[item.countKey] : 0;
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.exact}
                            className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
                        >
                            <span className="sidebar-icon">{item.icon}</span>
                            <span>{item.label}</span>
                            {count > 0 && <span className="sidebar-badge">{count}</span>}
                        </NavLink>
                    );
                })}
            </nav>
        </>
    );
}

